document.addEventListener('DOMContentLoaded', () => {

    const btn = document.querySelectorAll('.js-lessmore');

    const init = function () {
        let lang = 0;
        document.documentElement.lang === 'en-EN' ? lang = 1 : false;

        for (let i = 0; i < btn.length; i++) {

            btn[i].addEventListener('click', (e) => {
                e.preventDefault();

                const button = e.currentTarget;
                const target = document.querySelector(button.dataset.el);

                const isOnlyMore = button.hasAttribute('data-onlymore');

                // -------------------------
                // ONLY MORE MODE (ONE CLICK)
                // -------------------------
                if (isOnlyMore) {

                    if (!target) return;

                    target.classList.add('all-items');

                    button.innerHTML = JSON.parse(button.dataset.more)[lang];

                    // natychmiastowe ukrycie
                    button.style.display = 'none';

                    return;
                }

                // -------------------------
                // NORMAL TOGGLE MODE
                // -------------------------
                if (target.classList.contains('all-items')) {
                    target.classList.remove('all-items');
                    button.innerHTML = JSON.parse(button.dataset.more)[lang];
                } else {
                    target.classList.add('all-items');
                    button.innerHTML = JSON.parse(button.dataset.less)[lang];
                }
            });
        }
    };

    if (btn.length) init();

}, false);